import { createStore } from 'vuex'

export default createStore({
  state: {
    token: localStorage.getItem('X-FPRINT-TOKEN') || null,
    user: JSON.parse(localStorage.getItem('X-FPRINT-USER')) || null
  },
  mutations: {
    set_token (state, token) {
      state.token = token
    },
    set_user (state, user) {
      state.user = user
    }
  },
  actions: {
    set_token (context, token) {
      context.commit('set_token', token)
    },
    set_user (context, user) {
      context.commit('set_user', user)
    }
  },
  modules: {
  }
})
